@if (pageForm) {
  <div class="credit-info-container flex flex-column gap-3 mb-5">
    <div class="title-main">
      <app-translate key="ORDER_VERIFICATION"></app-translate>
    </div>
    <div>
      <span class="title-text">
        <app-translate key="CONFIRM_DATA_INSTRUCTION"></app-translate>
      </span>
    </div>
    <p-divider></p-divider>
    @if (fpvControls) {
      <div class="border-round">
        <div class="mb-4">
          <form [formGroup]="pageForm">
            <ng-container formArrayName="fpvControls">
              @for (item of fpvControls.controls; track item) {
                <div [formGroupName]="$index">
                  <div class="flex mb-2">
                    <span class="title-label">{{item.controls['Header'].value}}</span>
                  </div>
                  <div class="title-text pl-2">
                    <div class="flex gap-1">
                      <p-checkbox formControlName="Checked" [inputId]="'name-' + item.controls['Seq'].value"
                        [binary]="true" (onFocus)='sendCustomerAlertMessage(item.value)' />
                      <label [for]="'name-' + item.controls['Seq'].value" class="sub-title ml-2" [innerHTML]="item.controls['ItemHtml'].value">
                      </label>
                    </div>
                    <div>
                      <sp-control-error
                        [messagesParameters]="[{key : 'required', message : languageService.getTranslation('FIELD_MUST_BE_CONFIRMED')}]"
                      [control]="item.controls['Checked']"></sp-control-error>
                    </div>
                  </div>
                  <p-divider></p-divider>
                </div>
              }
            </ng-container>
            <!--Comments(Optional)-->
            <div>
              <div class="flex mb-2">
                <span class="title-label"><app-translate key="COMMENTS_OPTIONAL"></app-translate>:</span>
              </div>
              <div class="title-text">
                <textarea rows="3" class="w-full" cols="30" pTextarea formControlName="comments"
                (onFocus)="sendCustomerInputMessage('comments state')"></textarea>
              </div>
            </div>
          </form>
        </div>
        <p-divider></p-divider>
      </div>
    }
    <div>
      <div class="flex justify-content-between mb-2">
        <div><app-translate key="CLICK_SUBMIT_OR_SELECT_OPTIONS"></app-translate></div>
        <i class="pi pi-info-circle align-self-center" severity="secondary" tooltipPosition="top"
          (onClick)="legendPopover.toggle($event)" (mouseenter)="legendPopover.toggle($event)">
          <p-popover #legendPopover styleClass="border-1 border-round-lg w-4" my="center top"
            at="right center">
            <div class="flex flex-column ">
              <div class="align-items-center mb-2">
                <span class="font-bold mr-2"><app-translate key="SUBMIT"></app-translate>: </span>
                <app-translate key="SUBMIT_DESCRIPTION"></app-translate>
              </div>
              <div class="align-items-center mb-2">
                <span class="font-bold mr-2"><app-translate key="EDIT_ORDER"></app-translate>:</span>
                <app-translate key="EDIT_ORDER_DESCRIPTION"></app-translate>
              </div>
              <div class="align-items-center mb-2">
                <span class="font-bold mr-2"><app-translate key="CANCEL"></app-translate>:</span>
                <app-translate key="CANCEL_DESCRIPTION"></app-translate>
              </div>
            </div>
          </p-popover>
        </i>
      </div>
      <div class="flex flex-column">
        <div class="flex align-items-center justify-content-center">
          <div class="submit-btn-width mb-3">
            <p-button [label]="languageService.getTranslation('APPROVE')" (onClick)="onFormSubmit()"
              class="font-16" styleClass="text-sm p-button-lg w-full p-button-primary button" />
          </div>
        </div>
        <div class="flex align-items-center justify-content-center">
          <div class="cancel-btn-container mb-3">
            <div class="cancel-btn-width">
              <p-button [label]="languageService.getTranslation('CHANGE')" styleClass="text-sm" [link]="true"
                (onClick)="onEditForm()" />
            </div>
            <div class="cancel-btn-width">
              <p-button [label]="languageService.getTranslation('CANCEL')" styleClass="text-sm" [link]="true"
                (onClick)="onFormCancel()" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
      </div>
    </div>
  </div>
}

<app-confirm-popup [title]="languageService.getTranslation('CONFIRM_PURCHASE_QUESTION')"
  [header]="languageService.getTranslation('CONFIRM_PURCHASE')" [(isVisible)]="isSubmitVisible"
  (Result)="onPopupSubmit($event)"
(onFocus)="sendCustomerInputMessage('confirm purchase popup state')"></app-confirm-popup>

<app-confirm-popup [title]="languageService.getTranslation('CONFIRM_CHANGE_QUESTION')"
  [header]="languageService.getTranslation('CONFIRM_EDIT')" [(isVisible)]="isEditOrdertVisible"
(Result)="onPopupEdit($event)" (onFocus)="sendCustomerInputMessage('confirm edit popup state')"></app-confirm-popup>

<app-confirm-popup [title]="languageService.getTranslation('CONFIRM_CANCEL_QUESTION')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="isCancelVisible"
(Result)="onCancel($event)" (onFocus)="sendCustomerInputMessage('confirm cancel popup state')"></app-confirm-popup>